import { Row } from 'antd'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { Line } from 'src/components/helpers/line'
import { useTranslation } from 'next-i18next'
import { getFormatedPrice } from 'src/core/helpers'
import { DeveloperChartView } from 'src/core/models'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  CustomCard,
  FootPrintVsCompensationText,
  CustomCol,
  DevelopersChartViewSelector
} from 'src/components'
import {
  selectCurrencyToken,
  currencyListSelector,
  getIntegrationChartData,
  integrationChartDataSelector
} from 'src/features'

const BalanceVsTotalCompensateChart: React.FC<{ loading: boolean }> = ({
  loading
}) => {
  const { t } = useTranslation()
  const { id } = useRouter().query
  const dispatch = useAppDispatch()
  const [keySelected, setKeySelected] = useState<DeveloperChartView>('AMOUNT')
  const currencyList = useAppSelector(currencyListSelector)
  
  const { data, sum_amount, compensated_amount, currency_symbol } =
  useAppSelector(integrationChartDataSelector)

  const currencyCode = currencyList.find(
    (c) => c?.symbol === currency_symbol
  )?.code
  const visualCurrencyCode = useAppSelector(selectCurrencyToken)


  const yLabel = {
    AMOUNT: currency_symbol,
    COMPENSATED: 'tCO₂'
  }[keySelected]

  const config = {
    data,
    height: 250.5,
    xField: 'month',
    yField: 'compensated_amount',
    seriesField: 'integration_code',
    smooth: true,
    yAxis: {
      label: {
        formatter: (value: string) => `${value} ${yLabel}`
      }
    }
  }

  return (
    <CustomCard
      cardTitle={t('developers.Usage')}
      loading={loading}
      extra={
        <DevelopersChartViewSelector
          keySelected={keySelected}
          handleChange={(value) => {
            setKeySelected(value)
            dispatch(
              getIntegrationChartData(
                Number(id),
                visualCurrencyCode,
                value
              )
            )
          }}
        />
      }
    >
      <Row>
        <CustomCol xs={12}>
          <FootPrintVsCompensationText
            text1={t('developers.TotalValue')}
            text2={getFormatedPrice(sum_amount, currencyCode)}
          />
        </CustomCol>
        <CustomCol xs={12}>
          <FootPrintVsCompensationText
            text1={t('developers.TotalCompensated')}
            text2={`${compensated_amount} tCO₂`}
          />
        </CustomCol>
      </Row>
      <Line {...config} />
    </CustomCard>
  )
}

export default BalanceVsTotalCompensateChart
